module.exports = __webpack_public_path__ + "img/bg_mandala_02.96ab5172.jpg";